import { render, staticRenderFns } from "./ZincView.vue?vue&type=template&id=38e39c37&scoped=true"
import script from "./ZincView.vue?vue&type=script&lang=js"
export * from "./ZincView.vue?vue&type=script&lang=js"
import style0 from "./ZincView.vue?vue&type=style&index=0&id=38e39c37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e39c37",
  null
  
)

export default component.exports